import { HeroSection } from "./components/HeroSection"
import { ValueProposition } from "./components/ValueProposition"
import { FeaturesSection } from "./components/FeaturesSection"
import { BenefitsGrid } from "./components/BenefitsGrid"
import { CTASection } from "./components/CTASection"
import RipsCtaSection from "./RipsCTASection"
//import { HowItWorksSection } from "./components/how-it-works-section"
//import { IntegrationSection } from "./components/integration-section"
import { ClientsCarousel } from "./components/clients-carousel"
import { FAQSection } from "./components/faq-section"

export function HomePage() {
  return (
    <>
      <HeroSection />
    {/* <HowItWorksSection /> */}
      <ValueProposition />
      <FeaturesSection />
      <BenefitsGrid />
      
      <RipsCtaSection />
      <ClientsCarousel />
      <CTASection />
      <FAQSection />
    </>
  )
}
